"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _oneUnit = require("./oneUnit");

var _oneUnit2 = _interopRequireDefault(_oneUnit);

var _ErrorBoundary = require("../../components/ErrorBoundary");

var _ErrorBoundary2 = _interopRequireDefault(_ErrorBoundary);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Main = function Main(props) {
  var widthoffset = 0;
  if (props.chartSize == "medium") {
    widthoffset = 37;
  } else if (props.chartSize == "small") {
    widthoffset = 75;
  }
  return _react2.default.createElement(
    _ErrorBoundary2.default,
    null,
    _react2.default.createElement(_oneUnit2.default, {
      chartSize: props.chartSize,
      widthoffset: widthoffset,
      bgclr: "white",
      shouldRemainEqual: props.toggleEquality,
      paintShades: props.colorobject,
      pievalues: props.valuesobject
    })
  );
};

exports.default = Main;